import config from '../assets/config';
import { ax } from './base';


export default class dashboardService {
    
    GetDashboardCards(tenantID){
        return ax.get(`${config.apiUrl}common/GetDashboardCards/${tenantID}`);
    }

    GetHomeBudgetBarChart(tenantID,month,year){
        return ax.get(`${config.apiUrl}budget/GetHomeBudgetBarChart/${tenantID}/${month}/${year}`);
    }

    GetBudgetBarcart(tenantID,year,month){
        return ax.get(`${config.apiUrl}budget/GetBudgetBarcart/${tenantID}/${year}/${month}`);
    }

    GetPettyChashSplineChart(tenantID){
        return ax.get(`${config.apiUrl}common/GetPettyChashSplineChart/${tenantID}`);
    }
    GetDashboardReportCards(tenantID){
        return ax.get(`${config.apiUrl}common/GetDashboardReportCards/${tenantID}`);
    }
    GetProfitAndLossBarChart(tenantID){
        return ax.get(`${config.apiUrl}common/GetProfitAndLossBarChart?TenantID=${tenantID}`);
    }
    
    //Notification
    
    GetUserNotification(payload){
        return ax.post(`${config.apiUrl}common/GetUserNotification`,payload);
    }
    
    UpdateReadNotify(tenantID,UserID,NotificationID){
        return ax.put(`${config.apiUrl}common/UpdateReadNotify/${tenantID}/${UserID}/${NotificationID}`);
    }
    GetFeatureProducts(tenantID){
        return ax.get(`${config.apiUrl}Security/GetFeatureProducts/${tenantID}`);
    }
    
    //ticket rise
    
    RiseTicket(payload){
        return ax.post(`${config.apiUrl}Common/RiseTicket`,payload);
    }
    
    TicketsList(payload){
        return ax.post(`${config.apiUrl}Common/TicketsList`,payload);
    }
    
    //profile and reminder
    SaveUserReminder(payload){
        return ax.post(`${config.apiUrl}Common/SaveUserReminder`,payload);
    }
    GetReminder(payload){
        return ax.post(`${config.apiUrl}Common/GetReminder`,payload);
    }
    SaveAppUser(payload){
        return ax.post(`${config.apiUrl}Common/SaveAppUser`,payload);
    }
    SaveUserProfilePicture(payload){
        return ax.post(`${config.apiUrl}Common/SaveUserProfilePicture`,payload);
    }
    
    //Feature products
    GetMarketingImage(productID){
        return ax.get(`${config.apiUrl}security/GetMarketingImage/${productID}`);
    }
    GetMasBillingProfileModel(productID){
        return ax.get(`${config.apiUrl}Security/GetMasBillingProfileModel/${productID}`);
    }

    
    //signature
    GetAppUser(TenantID,AppUserID){
        return ax.get(`${config.apiUrl}Common/GetAppUser/${TenantID}/${AppUserID}`);
    }

    UpdateUserSignature(payload){
        return ax.post(`${config.apiUrl}common/UpdateUserSignature`,payload);
    }

    DownloadDocs(payload){
        return ax.post(`${config.apiUrl}Common/DownloadDocs`,payload);
    }

}
